'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var client = require('@apollo/client');
var useLomaClient = require('./useLomaClient.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ClaimsApolloProvider = _ref => {
  let {
    config,
    children
  } = _ref;
  const {
    LOMA_URL,
    handleError,
    links
  } = config;
  const {
    error,
    client: lomaClient
  } = useLomaClient["default"]({
    lomaUrl: LOMA_URL,
    handleError,
    links
  });
  if (error) throw error;
  if (!lomaClient) return null;
  return /*#__PURE__*/React__default["default"].createElement(client.ApolloProvider, {
    client: lomaClient
  }, children);
};

exports.ClaimsApolloProvider = ClaimsApolloProvider;
